import React from 'react';
import { Link } from 'react-router-dom';

export default {
  en: {
    card: [
      {
        title: 'Join the Community',
        description:
          'List your business for free and gain access to hundreds of new potential clients.',
        icon: require('ui/staticSiteData/descriptionForServiceProvidersData/images/image1.svg'),
      },
      {
        title: 'Communicate with Clients',
        description: (
          <>
            Upgrade to <Link to={'/premium-account'}>Pawzr Premium</Link> and
            directly message your clients.
          </>
        ),
        icon: require('ui/staticSiteData/descriptionForServiceProvidersData/images/image2.svg'),
      },
      {
        title: 'Manage Scheduling',
        description:
          'Add employee bios and keep track of hours and vacations with ease.',
        icon: require('ui/staticSiteData/descriptionForServiceProvidersData/images/image3.svg'),
      },
      {
        title: 'Highlight Your Company',
        description:
          'Market your business with a dedicated company profile. Promote your services, share reviews, and more.',
        icon: require('ui/staticSiteData/descriptionForServiceProvidersData/images/image4.svg'),
      },
    ],
    button: {
      text: 'List Your Business',
      link: '#',
    },
  },
};
